module.exports = __webpack_public_path__ + "media/images/eyeball-show-014877f1.svg";